import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';

const analytics = Analytics({
  app: 'cruises-frontend',
  plugins: [{
    name: 'console-logger',
    page: ({ payload }) => {
      console.log('page view', payload);
    },
    track: ({ payload }) => {
      console.log('track event', { event: payload.event, ...payload.properties });
    },
    identify: ({ payload }) => {
      console.log('identify', payload);
    },
  }, googleTagManager({
    containerId: 'GTM-N3XH75S',
  }),
  {
    name: 'woopra',
    track: ({ payload }) => {
      if (window.woopra) {
        window.woopra.track(payload.event, { ...payload.properties });
      }
    },
    identify: ({ payload }) => {
      if (window.woopra) {
        window.woopra.identify({ email: payload.userId });
      }
    },
  },
  {
    name: 'gtm-custom',
    identify: ({ payload }) => {
      if (window.dataLayer) {
        window.dataLayer.push({ email: payload.userId });
      }
    },
  },
  ],
});

export default analytics;
